module.exports = __webpack_public_path__ + "static/media/3.256d05e4.jpg";